module.exports = __webpack_public_path__ + "static/media/twitter16.60eb977c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/social-icons/twitter16.svg
// module id = 548
// module chunks = 0